import React from "react";
import { Box, makeStyles } from "@material-ui/core";
import Page from "../components/Page";
import ListInstallersContainer from "../containers/installers/ListInstallersContainer";
import List from "../views/installers/ListInstallers";

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    height: "100%",
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3),
  },
}));

const InstallersPage = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Ecat">
      <Box p={2}>
        <Box mb="7%">
          <ListInstallersContainer>
            {({ content, onSwitchAction }) => (
              <List
                onSwitchAction={onSwitchAction}
                items={content ? content : []}
              />
            )}
          </ListInstallersContainer>
        </Box>
      </Box>
    </Page>
  );
};

export default InstallersPage;
